module.exports = "https://www.gc-pro.gnp.com.mx/14c94b0c155d157731f346a2c43b45c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/documentos/01.png
// module id = 1028
// module chunks = 0 1